import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { getRequirementDefinitionTableCellProps } from "../../../../RequirementDefinitions/utils";
import { CustomRequirement } from "../../../types";
import { getPayoutMethodRequirementName } from "../../PayoutMethod/configs/helpers/getPayoutMethodRequirementName";
import { getPayoutMethodRequirementPayerStatusCell } from "../../PayoutMethod/configs/helpers/getPayoutMethodRequirementPayerStatusCell";
import { getClientsCellProps } from "../helpers/getClientsCellProps";

export function useGetPayoutMethodCustomRequirement(): (
  requirements: IRequirementResponse[]
) => CustomRequirement {
  return requirements => {
    const baseRequirement = requirements[0];

    return {
      payerId: baseRequirement.payerId,
      payerPayeeEngagementIds: baseRequirement.payerPayeeEngagementIds,
      status: baseRequirement.status,
      nameCell: {
        text: getPayoutMethodRequirementName(baseRequirement)
      },
      typeCell: getRequirementDefinitionTableCellProps({
        type: baseRequirement.requirementType
      }),
      clientsCell: getClientsCellProps(requirements),
      engagementsCell: {},
      statusCell: getPayoutMethodRequirementPayerStatusCell(baseRequirement),
      menuActions: []
    };
  };
}
